import { AppointmentEncounterMode } from '@dreryk/egabinet-appointment-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Dropdown, IconFillColor, IconWrapper, StyledFlex, VideoConsultationIcon } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

const t = patientTranslationKeys.encounterMode;

type VideoConsultationDropdownItemProps = {
   onClick: (appointmentEncounterMode: Extract<AppointmentEncounterMode, 'VIDEO_CONSULTATION'>) => Promise<void>;
};

export const VideoConsultationDropdownItem = (props: VideoConsultationDropdownItemProps): JSX.Element => {
   return (
      <Dropdown.Item
         testId={'videoConsultation'}
         onClick={async (hide) => props.onClick('VIDEO_CONSULTATION').finally(hide)}
      >
         <StyledFlex alignItems={'center'} gap={4}>
            <IconWrapper testId={'videoConsultation'} fillColor={IconFillColor.BACKGROUND}>
               <VideoConsultationIcon />
            </IconWrapper>
            <Translate>{t.VIDEO_CONSULTATION}</Translate>
         </StyledFlex>
      </Dropdown.Item>
   );
};
